import { createContext, useContext, useRef } from "react";

const LastClickedOrderContext = createContext<{
  getLastClickedOrderId: () => string | null;
  setLastClickedOrderId: (value: string | null) => void;
}>({
  getLastClickedOrderId: () => null,
  setLastClickedOrderId: () => {
    throw new Error("setLastClickedOrderId is not implemented");
  },
});

export function useLastClickedOrder() {
  return useContext(LastClickedOrderContext);
}

export function LastClickedOrderProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const lastClickedOrderId = useRef<string | null>(null);

  const getLastClickedOrderId = () => {
    return lastClickedOrderId.current;
  };

  const setLastClickedOrderId = (value: string | null) => {
    lastClickedOrderId.current = value;
  };

  return (
    <LastClickedOrderContext.Provider
      value={{ getLastClickedOrderId, setLastClickedOrderId }}
    >
      {children}
    </LastClickedOrderContext.Provider>
  );
}
